<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">
                        <h5 style="line-height: 30px">
                            Total : {{ selectedInvoice.currency_type | CurrencySymbol }}{{ selectedInvoice.invoice_amount }}<br>
                            Left  : {{ selectedInvoice.currency_type | CurrencySymbol }}{{ totalLeftAmount.toFixed(2) }}<br>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="col-md-12"></div>
        </div>
        <div class="box__header">
            <form class="form form--inline" >
                <div>
                <label for="filter_by_tour"> Select tour </label>
                    <v-select
                        label="name"
                        id="filter_by_tour"
                        placeholder="Filter by tour"
                        v-model="selectedTour"
                        index="id"
                        :options="tours"
                    />
                </div>

                <div>
                    <label for="d-from-date">Departure From Date</label>
                    <input id="d-from-date" type="date" v-model="departureFromDate"/>
                </div>

                <div>
                    <label for="d-to-date">Departure To Date</label>
                    <input id="d-to-date" type="date" v-model="departureToDate"/>
                </div>
                
                <div class="ml-1">
                <button type="button" class="button button--small" v-on:click="filterTourGroups">Search</button>
                </div>
            </form>
        </div>
        <hr/>
        <template v-if="filteredTourGroups.length > 0 ">
            <div class="row">
                <div class="col-md-11"></div>
                <div class="col-md-1">
                    <button type="button" class="button button--small" @click="submitTourLinking"> Submit </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <ul class="tour-pick-list">
                        <li class="tour-pick-list-item" v-for="group in filteredTourGroups" :key="group.id">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4> Departure Date: {{ group.start_date | formatDate }} </h4>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                              <label for="">Invoice Amount</label>
                                              <input type="number"
                                                    step="0.01"
                                                    class="form-control" 
                                                    placeholder="Invoice Amount" 
                                                    v-model="group.invoice_amount"
                                                    >
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="">Service Type</label>
                                                <v-select
                                                    label="service_name"
                                                    id="group_service_type"
                                                    index="service_type_id"
                                                    placeholder="Select Service type"
                                                    :options="service_types"
                                                    v-model="group.service_type"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="">Estimated Costs</label>
                                                <select class="form-control" name="" id="" v-model="group.selected_estimated_cost" style="height: auto;">
                                                  <option value="">Select</option>
                                                  <option v-for="payment in group.internal_payments" :key="payment.tour_group_payment_id" 
                                                        :value="payment.tour_group_payment_id">
                                                    {{ payment.service_types.service_name }} - {{ payment.estimated_cost }}
                                                  </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'InvoiceTourLinkModal',
    props: {
        paymentfor: String,
        paymentForObject:Object,
        selectedInvoice: Object,
        invoiceFor:Object,
        invoiceForTag: String,
        recordedPayments:Array, 
    },
    computed: {
        totalLeftAmount() {
            let consumedAmountForInternalPayments = 0; 
            if (this.selectedInvoice.internal_payments.length > 0) {
                this.selectedInvoice.internal_payments.forEach(element => {
                    consumedAmountForInternalPayments+= Number(element.invoice_amount)
                });
            }
            return this.selectedInvoice.invoice_amount - consumedAmountForInternalPayments
        }
    },
    data() {
        return {
            selectedTour: null,
            filteredTourGroups: [],
            departureFromDate: '',
            departureToDate: '',
            tours: null,
            service_types:[]

        }
    },
    created: function() {
        this.getTours()
        this.getServiceTypes()
    },
    methods: {
        getTours () {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'tours', {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.tours = response.data
                this.$store.dispatch('setLoadStatus')
            })
        },
        getServiceTypes () {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'service-types/list', {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.service_types = response.data
                this.$store.dispatch('setLoadStatus')
            })
        },
        filterTourGroups () {
            if(this.selectedTour !== null) {
                let qs = []
                this.filteredTourGroups = []
                if (this.departureFromDate !== ''){
                    qs.push("departureFromDate=" + this.departureFromDate)
                }
                
                if (this.departureToDate !== ''){
                    qs.push("departureToDate=" + this.departureToDate)
                }
                qs.push("serviceEstimateCost=" + true)
                this.$store.dispatch('setLoadStatus')
                fetch(this.$api + 'tours/' + this.selectedTour + '/groups?' + qs.join('&'), {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
                })
                .then(res => res.json())
                .then(response => {
                    this.filteredTourGroups = []
                    if (response.data.length > 0 ) {
                        response.data.forEach(element => {
                            this.filteredTourGroups.push({
                                group_id: element.id,
                                start_date: element.start_date,
                                invoice_amount: null,
                                service_type: null,
                                internal_payments: element.internal_payments,
                                selected_estimated_cost:null
                            })
                        });
                    }
                    this.$store.dispatch('setLoadStatus')
                })

            }
        }, 
        submitTourLinking() {
            // step 1:- Filter out all those group where invoice amount and serivce type is selected
            let selectedGroups = this.filteredTourGroups.filter(element => (element.invoice_amount && element.service_type))
            if (selectedGroups.length > 0) {

                let submitObject = {
                    invoice_id:this.selectedInvoice.id,
                    invoice_for:this.invoiceForTag,
                    invoice_for_id: this.invoiceFor.id,
                    selected_groups:selectedGroups
                }    

                this.$store.dispatch('setLoadStatus')
                fetch(`${this.$api}invoice/link-groups`, {
                    method: 'POST',
                    body: JSON.stringify(submitObject),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    this.errors = response.errors
                    if(response.status) {
                        this.$notify({
                            type: 'success',
                            title: response.message
                        });
                        this.$emit('syncInvoices')
                    } else if (response.errors) {
                        this.$notify({
                            type: 'error',
                            title: response.message
                        });
                    }
                    this.$store.dispatch('setLoadStatus')
                });

            }
        }
    }
}
</script>

<style lang="scss" scoped>
ul.tour-pick-list{
    list-style: none;
    margin: 0px !important;
    padding: 0px;
}
ul li.tour-pick-list-item{
    border: 1px solid black;
    border-radius: 12px;
    padding: 20px;
    margin-top: 8px;
}
</style>